import React, { useEffect, useState } from "react";

import { message, theme } from "antd";
import { Outlet, useNavigate } from "react-router";
import "./MasterLayout.scss";

import PrimaryNav from "../PrimaryNav";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
import { apiGet } from "app/services/apiServices";
import Loader from "../Loader";
import AppLoader from "../AppLoader";

const MasterLayout = (props: any) => {
  const [expandedLayout, setExpandedLayout] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    setLoading(true);
    const response = await apiGet(API_ENDPOINT_GET_USER_INFO);
    if (response.status) {
      let mmtWorkspace = (response.data.workspaces || []).find(
        (item: any) => item.name === "MMT Admin"
      );
      console.log("mmt workspace", mmtWorkspace);
      setUserDetails({
        ...response.data,
        currentWorkspace: mmtWorkspace
          ? mmtWorkspace
          : response.data.workspaces[0],
        clusterId: response.data.cluster_id,
      });
      localStorage.setItem(
        "currentWorkspace",
        mmtWorkspace ? mmtWorkspace.id : response.data.workspaces[0]?.id
      );
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return isLoading ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <AppLoader />
    </div>
  ) : (
    <div className="MasterLayout">
      <div className="NavigationContainer">
        <PrimaryNav openMenu={() => setExpandedLayout(!expandedLayout)} />
      </div>
      {/* {userDetails.hasOnboared ? (
        <div
          className="PendingTaskContainer"
          style={{ display: expandedLayout ? "flex" : "none" }}
        >
          <OnboardingTasks />
        </div>
      ) : null} */}
      <div
        className={
          "ContentLayout maxWidthLG " +
          (expandedLayout ? " " : " CollapsedLayout")
        }
      >
        <div className="AppContent">
          <Outlet />
        </div>
      </div>
      {contextHolder}
    </div>
  );
};

export default MasterLayout;
